import React, { FormEvent, useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Style
import * as S from './style';

const Input: React.FC = () => {
    const history = useHistory();
    const [error, setError] = useState<string>()
    const [text, setText] = useState('');

    React.useEffect(() => {
        let timer = setTimeout(() => setError(''), 2000)
        return () => clearTimeout(timer);
    }, [error])

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (text) {
            history.push(`/search/${text}`)
        } else {
            setError('Please fill the form')
        }
    }
    
    return (
        <>
            <S.SearchForm onSubmit={handleSubmit}>
                <S.Input onChange={e => setText(e.target.value)} type="text" placeholder={'Cerca'} />
                <button className="search-btn">
                    <i className="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30">
                            <defs>
                                <clipPath id="search">
                                    <rect width="23" height="23" fill="none"/>
                                </clipPath>
                            </defs>
                            <g id="search" clipPath="url(#search)">
                                <circle id="Ellisse_123" data-name="Ellisse 123" cx="8" cy="8" r="8" transform="translate(1.5 1.5)" fill="none" stroke="#c5e28c" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="3"/>
                                <path id="Tracciato_3400" data-name="Tracciato 3400" d="M22,22l-6-6" transform="translate(-0.5 -0.5)" fill="none" stroke="#c5e28c" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="3"/>
                            </g>
                        </svg>
                    </i>
                </button>
            </S.SearchForm>
            {error && (
                <S.Error>
                    <i className="icon">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle" className="svg-inline--fa fa-exclamation-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path></svg>
                    </i>
                    <span>{error}</span>
                </S.Error>
            )}
        </>
    )
}

export default Input;
